import { Head } from "@inertiajs/inertia-react";
import {
    BriefcaseIcon,
    ClockIcon,
    HomeIcon,
    MailIcon,
    PhoneIcon,
} from "@heroicons/react/solid";
import { useForm } from "@inertiajs/inertia-react";
import ValidationErrors from "@/Components/ValidationErrors";
import Notification from "@/Components/Notification";

export default () => {
    const { data, setData, post, processing, errors, reset } = useForm({
        name: "",
        email: "",
        phone: "",
        location: "",
        origin: "",
        subject: "",
        message: "",
    });

    const onHandleChange = (event) => {
        setData(event.target.name, event.target.value);
    };

    const submit = (e) => {
        e.preventDefault();

        post("/contact", {
            preserveScroll: true,
            onSuccess: () => {
                reset();
            },
        });

        console.log(errors);
    };
    return (
        <div className="relative pb-24 pt-4 bg-sky-800 sm:pb-32" id="contact">
            <div className="absolute inset-0">
                <picture>
                    <source
                        srcSet="/assets/webp/personal-training-schijndel-uden.webp"
                        type="image/webp"
                        alt="Personal training locatie Schijndel en Uden"
                        className="w-full h-full object-cover"
                    />
                    <source
                        srcSet="/assets/personal-training-schijndel-uden.jpg"
                        type="image/jpeg"
                        alt="Personal training locatie Schijndel en Uden"
                        className="w-full h-full object-cover"
                    />
                    <img
                        src="/assets/personal-training-schijndel-uden.jpg"
                        alt="Personal training locatie Schijndel en Uden"
                        className="w-full h-full object-cover"
                    />
                </picture>
            </div>
            <div className="relative mt-12 max-w-md mx-auto px-4 sm:max-w-3xl sm:mt-32 sm:px-6 lg:max-w-7xl lg:px-8">
                <h2 className="xs:text-center sm:text-center italic uppercase  xl:inline  xs:text-4xl sm:text-4xl md:text-4xl lg:text-5xl font-bold font-custom tracking-tight text-white">
                    Laten we elkaar ontmoeten!
                </h2>
                <p className="mt-6 text-lg text-gray-100 max-w-3xl">
                    Één klik op onderstaande knop kan het begin zijn van jouw
                    transformatie. We zijn benieuwd naar wie je bent en waar we
                    je mee kunnen helpen. Hopelijk zien we je snel om je eens te
                    mogen ontmoeten.
                </p>

                <p className="mt-6 text-lg text-gray-100 max-w-3xl font-bold underline">
                    Mocht er binnen 24 uur geen contact zijn opgenomen stuur ons dan een bericht op (ons mobiele nummer). 
                </p>

                <div className="grid grid-cols-1 lg:grid-cols-3">
                    {/* Contact form */}
                    <div className="py-10 lg:pr-10 lg:col-span-2 lg:py-12">
                        {/* <div
                            id="calendly"
                            className="calendly-inline-widget"
                            // dataurl="https://calendly.com/wearepersonaltraining/gratiskennismaken"
                            style={{ minWidth: " 320px", height: "800px" }}
                        ></div> */}

                        <ValidationErrors errors={errors} />
                        <Notification />

                        <form
                            onSubmit={submit}
                            method="POST"
                            className="mt-6 grid grid-cols-1 gap-y-6 sm:grid-cols-2 sm:gap-x-8"
                        >
                            <div className="sm:col-span-2">
                                <label
                                    htmlFor="name"
                                    className="block text-sm font-medium text-gray-100"
                                >
                                    Volledige naam
                                </label>
                                <div className="mt-1">
                                    <input
                                        onChange={onHandleChange}
                                        value={data.name}
                                        type="text"
                                        name="name"
                                        id="name"
                                        autoComplete="given-name"
                                        className="bg-black border-none py-3 px-4 block w-full shadow-sm text-gray-100 focus:ring-we-are-purple focus:border-we-are-purple rounded-md"
                                    />
                                </div>
                            </div>
                            <div>
                                <label
                                    htmlFor="email"
                                    className="block text-sm font-medium text-gray-100"
                                >
                                    E-mailadres
                                </label>
                                <div className="mt-1">
                                    <input
                                        onChange={onHandleChange}
                                        value={data.email}
                                        id="email"
                                        name="email"
                                        type="email"
                                        autoComplete="email"
                                        className="bg-black border-none py-3 px-4 block w-full shadow-sm text-gray-100 focus:ring-we-are-purple focus:border-we-are-purple rounded-md"
                                    />
                                </div>
                            </div>
                            <div>
                                <div className="flex justify-between">
                                    <label
                                        htmlFor="phone"
                                        className="block text-sm font-medium text-gray-100"
                                    >
                                        Telefoonnummer
                                    </label>
                                </div>
                                <div className="mt-1">
                                    <input
                                        onChange={onHandleChange}
                                        value={data.phone}
                                        type="text"
                                        name="phone"
                                        id="phone"
                                        autoComplete="tel"
                                        className="bg-black border-none py-3 px-4 block w-full shadow-sm text-gray-100 focus:ring-we-are-purple focus:border-we-are-purple rounded-md"
                                        aria-describedby="phone-optional"
                                    />
                                </div>
                            </div>
                            <div className="sm:col-span-2">
                                <label
                                    htmlFor="location"
                                    className="block text-sm font-medium text-gray-100"
                                >
                                    Locatie
                                </label>
                                <div className="mt-1">
                                    <select
                                        onChange={onHandleChange}
                                        value={data.location}
                                        name="location"
                                        id="location"
                                        className="bg-black border-none py-3 px-4 block w-full shadow-sm text-gray-100 focus:ring-we-are-purple focus:border-we-are-purple rounded-md"
                                    >
                                        <option value="" disabled>
                                            Kies een locatie
                                        </option>
                                        <option value="Uden">Uden</option>
                                        <option value="Schijndel">
                                            Schijndel
                                        </option>
                                    </select>
                                </div>
                            </div>
                            <div className="sm:col-span-2">
                                <label
                                    htmlFor="subject"
                                    className="block text-sm font-medium text-gray-100"
                                >
                                    Hoe heb je ons gevonden
                                </label>
                                <div className="mt-1">
                                    <select
                                        onChange={onHandleChange}
                                        value={data.origin}
                                        name="origin"
                                        id="origin"
                                        className="bg-black border-none py-3 px-4 block w-full shadow-sm text-gray-100 focus:ring-we-are-purple focus:border-we-are-purple rounded-md"
                                    >
                                        <option disabled value="">
                                            Kies een optie
                                        </option>
                                        <option value="Instagram / Facebook">
                                            Instagram / Facebook
                                        </option>
                                        <option value="Google">Google</option>
                                        <option value="Via-via">Via-via</option>
                                        <option value="Overig">Overig</option>
                                    </select>
                                </div>
                            </div>
                            <div className="sm:col-span-2">
                                <div className="flex justify-between">
                                    <label
                                        htmlFor="message"
                                        className="block text-sm font-medium text-gray-100"
                                    >
                                        Vertel ons jouw doel
                                    </label>
                                </div>
                                <div className="mt-1">
                                    <textarea
                                        onChange={onHandleChange}
                                        value={data.message}
                                        id="message"
                                        name="message"
                                        rows={4}
                                        className="bg-black border-none py-3 px-4 block w-full shadow-sm text-gray-100 focus:ring-we-are-purple focus:border-we-are-purple border rounded-md"
                                        aria-describedby="message-max"
                                    />
                                </div>
                            </div>
                            <div className="sm:col-span-2 sm:flex sm:justify-end">
                                <button
                                    type="submit"
                                    className="mt-2 w-full inline-flex items-center justify-center px-6 py-3 border border-transparent rounded-md shadow-sm text-base font-medium text-white bg-we-are-purple focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-we-are-purple sm:w-auto"
                                >
                                    Verzend
                                </button>
                            </div>
                        </form>
                    </div>

                    {/* Contact information */}
                    <div className="relative overflow-hidden py-10">
                        <dl className="mt-8 space-y-6">
                            <dt>
                                <span className="sr-only">Telefoonnummer</span>
                            </dt>
                            <dd className="flex text-base text-gray-100">
                                <PhoneIcon
                                    className="flex-shrink-0 w-6 h-6 text-we-are-yellow"
                                    aria-hidden="true"
                                />
                                <span className="ml-3">+31 6 36 12 35 42</span>
                            </dd>
                            <dt>
                                <span className="sr-only">Email</span>
                            </dt>
                            <dd className="flex text-base text-gray-100">
                                <MailIcon
                                    className="flex-shrink-0 w-6 h-6 text-we-are-yellow"
                                    aria-hidden="true"
                                />
                                <span className="ml-3">info@we-are.club</span>
                            </dd>
                            <dt>
                                <span className="sr-only">Adres</span>
                            </dt>
                            <dd className="flex text-base text-gray-100">
                                <HomeIcon
                                    className="flex-shrink-0 w-6 h-6 text-we-are-yellow"
                                    aria-hidden="true"
                                />
                                <span className="ml-3">
                                    Vluchtoord 42a, 5406 XP Uden
                                </span>
                                <span className="ml-3">
                                    Spoorlaan 18D, 5481 SK Schijndel
                                </span>
                            </dd>
                            <dd className="flex text-base text-gray-100">
                                <BriefcaseIcon
                                    className="flex-shrink-0 w-6 h-6 text-we-are-yellow"
                                    aria-hidden="true"
                                />
                                <span className="ml-3">
                                    BTW-id: NL863041346B01
                                </span>
                            </dd>
                            <dd className="flex text-base text-gray-100">
                                <BriefcaseIcon
                                    className="flex-shrink-0 w-6 h-6 text-we-are-yellow"
                                    aria-hidden="true"
                                />
                                <span className="ml-3">
                                    KvK-nummer Uden: 83938141
                                </span>
                                <span className="ml-3">
                                    KvK-nummer Schijndel: 84447532
                                </span>
                            </dd>
                        </dl>
                    </div>
                </div>
            </div>
        </div>
    );
};
